import { createContext, useContext, useState, ReactNode } from 'react'

interface InvoiceLineItem {
  id: string
  amount: string
  isConfirmed: boolean
  touched?: boolean
  error?: string
  originalAmount?: string
  originalId?: string
}

interface InvoiceLineItemContextProps {
  invoiceLineItems: InvoiceLineItem[]
  setInvoiceLineItems: React.Dispatch<React.SetStateAction<InvoiceLineItem[]>>
  addInvoiceLineItemRow: () => void
  existingInvoiceLineItems: InvoiceLineItem[]
  setExistingInvoiceLineItems: React.Dispatch<React.SetStateAction<InvoiceLineItem[]>>
}

const InvoiceLineItemContext = createContext<InvoiceLineItemContextProps | undefined>(undefined)

export const useInvoiceLineItemsContext = (): InvoiceLineItemContextProps => {
  const context = useContext(InvoiceLineItemContext)
  if (!context) {
    throw new Error('useInvoiceLineItemsContext must be used within an InvoiceLineItemProvider')
  }
  return context
}

export const InvoiceLineItemProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [invoiceLineItems, setInvoiceLineItems] = useState<InvoiceLineItem[]>([])
  const [existingInvoiceLineItems, setExistingInvoiceLineItems] = useState<InvoiceLineItem[]>([])

  const addInvoiceLineItemRow = () => {
    setInvoiceLineItems((prevItems) => [
      ...prevItems,
      { id: '', amount: '', isConfirmed: false, touched: false, error: undefined },
    ])
  }

  return (
    <InvoiceLineItemContext.Provider
      value={{
        invoiceLineItems,
        setInvoiceLineItems,
        addInvoiceLineItemRow,
        existingInvoiceLineItems,
        setExistingInvoiceLineItems,
      }}
    >
      {children}
    </InvoiceLineItemContext.Provider>
  )
}
